module.exports = __webpack_public_path__ + "assets/img/house-7.5fbaf31f.jpeg";